<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-10-14 16:59:06
-->
<template>
  <el-input
    ref="input"
    class="component__input-number"
    :value="displayValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :max="max"
    :min="min"
    @blur="handleBlur"
    @input="handleInput"
  >
  </el-input>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    placeholder: String,
    disabled: Boolean,
    size: String,
  },
  data() {
    return {
      userInput: null,
      validValue: this.value,
    };
  },
  methods: {
    _setValue(val) {
      let newVal = val;
      if (val > this.max) newVal = this.max;
      if (val < this.min) newVal = this.min;
      this.validValue = newVal;
      if (newVal != this.value) {
        this.$emit("input", newVal);
      }
    },
    handleBlur() {
      this.userInput = null;
    },
    handleInput(value) {
      console.log("#-# handle input?");
      this.userInput = value;
      const newVal = value == "" ? undefined : Number(value);
      if (!isNaN(newVal)) {
        this._setValue(newVal);
      }
    },
  },
  watch: {
    value(newValue) {
      this.validValue = newValue;
    },
  },
  computed: {
    displayValue() {
      if (this.userInput != null) {
        return this.userInput;
      }
      return this.validValue;
    },
  },
};
</script>

<style lang="scss">
.component__input-number{
  input{
    padding: 0px 6px;
    text-align: center;
  }
}
</style>